import { MultiProgramDeviceFlowProvider } from '@/app/context/MultiProgram/MultiProgramFlowContexts'
import ProgramCardAccordion from '@/components/ProgramCardAccordion/ProgramCardAccordion'
import { UtilityProgram } from '@/types/utilityProgram'

type UtilityProgramLearnMoreDashboardViewProps = {
  availablePrograms: UtilityProgram[]
}

export default function UtilityProgramMultiProgramLearnMoreCard(
  props: UtilityProgramLearnMoreDashboardViewProps,
) {
  return (
    <MultiProgramDeviceFlowProvider>
      <ProgramCardAccordion
        title={`Available Programs (${props.availablePrograms.length})`}
        programs={props.availablePrograms}
        initialState={'open'}
        enrolled={false}
      />
    </MultiProgramDeviceFlowProvider>
  )
}
